import { useParams } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'
import Answer from 'modules/reviews/components/Review/Answer'
import { useQuestionGroup } from 'modules/reviews/hooks/useQuestionGroup'
import { useQuestionGroupCompetencies } from 'modules/reviews/hooks/useQuestionGroupsCompetencies'

const ReviewAnswerPage = () => {
  const { navigation } = useNavigation()

  const { id: formId, question_group_id: questionGroupId } = useParams()
  const { performanceFeatureAvailability } = usePerformanceModuleContext()
  const canSeeCompetencies = performanceFeatureAvailability.canSeeCompetencies
  const { loading: loadingCompetencies } = useQuestionGroupCompetencies(canSeeCompetencies)
  const { loading, questionGroup, refresh } = useQuestionGroup(Number(questionGroupId))
  const {
    access: { id: userId },
  } = useCurrentSession()
  const isQuestionGroupRespondent = questionGroup?.respondent?.id === userId

  const isAuthorized = () => {
    if (loading) return true

    return isQuestionGroupRespondent
  }

  return (
    <AuthorizeUser authorizeFn={isAuthorized}>
      <Answer
        useResponsivePage
        formId={Number(formId)}
        loadingQuestionGroup={loading}
        loadingCompetencies={loadingCompetencies}
        questionGroup={questionGroup}
        refresh={refresh}
        back={navigation.performance.reviews.id.writeReviews.fullPath({ id: Number(formId) })}
      />
    </AuthorizeUser>
  )
}

export default ReviewAnswerPage
